(function($) {
    var timer = 500,
        tl = {
            'close' : 'Fermer',
            'valid' : 'Ok',
            'cancel' : 'Annuler'
        };

    /* Popins
     *
     * - create message box (type alert) : $.popin.alert(params);
     *   @params (object) :
     *      message    : message of the popin (string) | mandatory
     *      [title]    : title of the popin (string) | optionnal | default = ""
     *      [button]   : label of the button (string) | optionnal | default = "Ok"
     *      [callback] : function call after click on the button (function) | optionnal | default = null
     *      [fCalled] : function call after popin creation (function) | optionnal | default = null
     *  example :
     *      <input type="button" onclick="$.popin.alert({message: 'Corps du message', title: 'titre', button: Valider', callback: function{}});" value="Cliquer ici">
     *
     * - create message box (type confirm) : $.popin.confirm(params);
     *   @params (object) :
     *      message      : message of the popin (string) | mandatory
     *      [title]      : title of the popin (string) | optionnal | default = ""
     *      [button]     : label of the valid button (string) | optionnal | default = "Ok"
     *      [buttonCl]   : label of the cancel button (string) | optionnal | default = "Annuler"
     *      [callback]   : function call after click on the valid button (function) | optionnal | default = null
     *      [callbackCl] : function call after click on the cancel button (function) | optionnal | default = null
     *      [fCalled] : function call after popin creation (function) | optionnal | default = null
     * example :
     *      <input type="button" onclick="$.popin.confirm({message: 'Corps du message', title: 'titre', button: Valider', buttonCl: 'Annuler', callback: function{}, callbackCl: function{}});" value="Cliquer ici">
     *
     * */
    $.popin = {
        create : function (type, title, msg, $btnValid, $btnCancel, fCalled) {
            if($('#popin').length) {
                $.popin.close();
            }
            if (type == undefined) {
                type = 'info';
            }
            if (title == undefined) {
                title = '';
            }

            /* Create Elements */
            var $popin = $('<div>', {id: 'popin', 'class':'popin ' + type}),
                html = '';

            html += '<div class="popinContent">';
                if (title != '') {
                    html += '<button class="popinClose"><span>' + tl.close + '</span></button>';
                    html += '<div class="popinTitle">' + (title ? title : '') + '</div>';
                }
                html += '<div class="popinMessage">' + (msg ? msg : '') + '</div>';
                html += '<div class="popinButton"></div>';
            html += '</div>';

            $popin.html(html);
            $('body').append($popin);

            if($btnCancel) {
                $('.popinButton', $popin).append($btnCancel);
            }

            if($btnValid) {
                $('.popinButton', $popin).append($btnValid);
            }

            /* Init functions */
            if(fCalled) {
                fCalled();
            }

            $('.popinContent', $popin).css({opacity: 0, top: 10}).animate({opacity:1, top: 0}, timer, function() {
                /* Bind close */
                $('.popinClose', $popin).click(function() {
                    $.popin.close();
                });

                $popin.mousedown(function(e) {
                    if (!$.contains($popin[0], e.target)) {
                        $.popin.close();
                    }
                });
            });
            $popin.trigger('popinCreated');
        },
        close : function(callback) {
            var $popin = $('#popin'),
                isOk = true;

            if($popin.length) {
                if(callback) {
                    isOk = callback();
                }

                if(isOk) {
                    $('.popinContent', $popin).css({opacity: 1, top: 0}).animate({opacity:0, top: 10}, timer, function() {
                        $popin.remove();
                    });
                }
            }
            $popin.trigger('popinClosed');
        },
        replace : function() {
            var $popin = $('#popin');
            $popin.remove();

        },
        alert : function(options) {
            if(options.message) {
                var $btn = $('<button>', {'class':'btnValid bouton', text: options.button ? options.button : tl.valid});

                $btn.click(function() {
                    $.popin.close(options.callback);
                });

                $.popin.create(options.type, options.title, options.message, $btn, '', options.fCalled);
            }
        },
        confirm : function(options) {
            if(options.message) {
                if(options.button)
                  var $btnValid = $('<button>', {'class':'btnValid bouton', text: options.button ? options.button : tl.valid});
                else
                  var btnValid = false;
                console.log('btnValid'+btnValid);
                if(options.buttonCl)
                  var $btnCancel= $('<button>', {'class':'btnCancel', text: options.buttonCl ? options.buttonCl : tl.cancel});
                else
                  var btnCancel = false;

                if($btnValid)
                $btnValid.click(function() {
                    $.popin.close(options.callback);
                });

                if($btnCancel)
                $btnCancel.click(function() {
                    $.popin.close(options.callbackCl);
                });

                $.popin.create(options.type, options.title, options.message, $btnValid, $btnCancel, options.fCalled);
            }
        }
    };
})(jQuery);


(function($){
$(document).ready(function() {
    var messagePopin = $(".popinmessage").html().trim(),
        typePopin = $(".popinmessage").data("type"),
        titlePopin = $(".popinmessage").data("title"),
        buttonPopin = $(".popinmessage").data("button");
    if (messagePopin != "") {
      $.popin.alert({type: typePopin, title: titlePopin, message: messagePopin, button: buttonPopin});
      $(".popinmessage").remove();
    }
  }); // document.ready
})(jQuery);